import { render, staticRenderFns } from "./ResetPasswordPage.vue?vue&type=template&id=08f0971e&scoped=true&"
import script from "./ResetPasswordPage.vue?vue&type=script&lang=js&"
export * from "./ResetPasswordPage.vue?vue&type=script&lang=js&"
import style0 from "./ResetPasswordPage.vue?vue&type=style&index=0&id=08f0971e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f0971e",
  null
  
)

export default component.exports